import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Link } from 'components/link';

const Container = styled.div`
  text-align: center;
  margin: 1rem;
  font-size: 0.9rem;
  white-space: normal;
`;

const TermsLink = styled(Link)`
  color: ${Styles.color.primary};
  text-transform: capitalize;
`;

export const DeliveryTerms: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <Container>
      {formatMessage(
        { id: 'deliveryTerms' },
        {
          link: (
            <TermsLink to={formatMessage({ id: 'routes.deliveryTerms' })}>
              {formatMessage({ id: 'here' })}
            </TermsLink>
          ),
        }
      )}
    </Container>
  );
};
